/* SOULSHAE — theme.js */
(function () {
  'use strict';
 
  /* ─── Helpers ─────────────────────────────────────────────────── */
  const $  = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));
 
  const moneyFormat = (window.theme && window.theme.moneyFormat) || '€{{amount}}';

  function formatMoney(cents, fmt) {
    const f = fmt || moneyFormat;
    cents = parseInt(cents, 10) || 0;

    function withComma(num) {
      // Ondalık: virgül, binlik: nokta  →  1.234,56
      const parts = (num / 100).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return parts.join(',');
    }
    function withDot(num) {
      // Ondalık: nokta, binlik: virgül  →  1,234.56
      const parts = (num / 100).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    function noDecimalsComma(num) {
      return String(Math.round(num / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    function noDecimals(num) {
      return String(Math.round(num / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    return f
      .replace(/{{\s*amount_with_comma_separator\s*}}/g, withComma(cents))
      .replace(/{{\s*amount_no_decimals_with_comma_separator\s*}}/g, noDecimalsComma(cents))
      .replace(/{{\s*amount_no_decimals\s*}}/g, noDecimals(cents))
      .replace(/{{\s*amount\s*}}/g, withDot(cents));
  }
 
  function on(el, evt, fn) {
    if (!el) return;
    el.addEventListener(evt, fn);
  }
 
  /* ─── Mobile menu ─────────────────────────────────────────────── */
  const mobileMenu = $('#mobile-menu');
  const mobileToggle = $('[data-mobile-toggle]');
  const mobileClose = $('[data-mobile-close]');
 
  function openMobileMenu()  { if (mobileMenu) mobileMenu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeMobileMenu() { if (mobileMenu) mobileMenu.classList.remove('is-open'); document.body.style.overflow = ''; }
 
  on(mobileToggle, 'click', openMobileMenu);
  on(mobileClose, 'click', closeMobileMenu);
 
  /* ─── Cart drawer ─────────────────────────────────────────────── */
  const cartDrawer  = $('#cart-drawer');
  const cartOverlay = $('#cart-drawer-overlay');
  const cartOpenBtns  = $$('[data-cart-open]');
  const cartCloseBtns = $$('[data-cart-close]');
 
  function openCart() {
    if (!cartDrawer) return;
    refreshCart().finally(() => {
      cartDrawer.classList.add('is-open');
      if (cartOverlay) cartOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
 
  cartOpenBtns.forEach(b => on(b, 'click', (e) => { e.preventDefault(); openCart(); }));
  cartCloseBtns.forEach(b => on(b, 'click', closeCart));
  on(cartOverlay, 'click', closeCart);
 
  on(document, 'keydown', (e) => {
    if (e.key === 'Escape') { closeCart(); closeMobileMenu(); }
  });
 
  /* ─── Cart fetch + render ─────────────────────────────────────── */
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(renderCartDrawer)
      .catch(err => console.warn('[cart] fetch failed', err));
  }
 
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(el => {
      el.textContent = '(' + count + ')';
      el.style.display = count > 0 ? '' : 'none';
    });
  }
 
  function renderCartDrawer(cart) {
    if (!cartDrawer) return;
    const body  = $('[data-cart-body]', cartDrawer);
    const total = $('[data-cart-total]', cartDrawer);
    const cta   = $('[data-cart-checkout]', cartDrawer);
 
    updateCartCount(cart.item_count);
 
    if (cart.item_count === 0) {
      if (body) body.innerHTML = '<div class="cart__empty" style="padding:48px 0;">Your bag is quiet for now.</div>';
      if (total) total.textContent = '';
      if (cta) cta.style.display = 'none';
      return;
    }
 
    if (cta) cta.style.display = '';
 
    if (body) {
      body.innerHTML = cart.items.map(item => `
        <div class="cart__item" data-line="${item.key}">
          <div class="cart__item-media">
            ${item.featured_image && item.featured_image.url ? `<img src="${item.featured_image.url}" alt="${item.product_title}">` : ''}
          </div>
          <div>
            <div class="cart__item-title">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart__item-variant">${item.variant_title}</div>` : ''}
            <div class="cart__qty" style="margin-top:10px;">
              <button class="cart__qty-btn" data-line-change="${item.key}" data-direction="-1">−</button>
              <input class="cart__qty-input" type="text" value="${item.quantity}" readonly>
              <button class="cart__qty-btn" data-line-change="${item.key}" data-direction="1">+</button>
            </div>
            <button class="cart__remove" data-line-remove="${item.key}">Remove</button>
          </div>
          <div class="cart__item-price">${formatMoney(item.final_line_price)}</div>
        </div>
      `).join('');
    }
 
    if (total) total.textContent = formatMoney(cart.total_price);
 
    // Attach handlers
    $$('[data-line-change]', body).forEach(btn => {
      on(btn, 'click', () => {
        const key = btn.getAttribute('data-line-change');
        const dir = parseInt(btn.getAttribute('data-direction'), 10);
        changeQuantity(key, dir);
      });
    });
    $$('[data-line-remove]', body).forEach(btn => {
      on(btn, 'click', () => {
        const key = btn.getAttribute('data-line-remove');
        updateQuantity(key, 0);
      });
    });
  }
 
  function changeQuantity(key, direction) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        const item = cart.items.find(i => i.key === key);
        if (!item) return;
        const newQty = Math.max(0, item.quantity + direction);
        return updateQuantity(key, newQty);
      });
  }
 
  function updateQuantity(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(r => r.json())
      .then(renderCartDrawer);
  }
 
  /* ─── Add to cart form ────────────────────────────────────────── */
  $$('form.product-form').forEach(form => {
    on(form, 'submit', (e) => {
      e.preventDefault();
      const submitBtn = $('[type="submit"]', form);
      if (submitBtn) submitBtn.disabled = true;
 
      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(r => r.json())
        .then(() => {
          openCart();
        })
        .catch(err => {
          console.error('[add-to-cart]', err);
          alert('Could not add to bag. Please try again.');
        })
        .finally(() => {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  });
 
  /* ─── Product page — variant selection ────────────────────────── */
  $$('form.product-form').forEach(form => {
    let variantData = window.productVariants || [];
    // 256 variant: Liquid sadece ilk 250'yi verir. Storefront API tum listeyi
    // yukleyene kadar variantsReady=false. Eslesme bulunamayinca, liste eksikse
    // "Sold out" deme — "Loading" de ve butonu pasif tut.
    // 250 cap: Liquid product.variants.size bile 250'de tavanlanir, bu yuzden
    // needsMore guvenilmez. loadedCount 250'ye ulastiysa muhtemelen daha fazlasi
    // vardir -> Storefront API'den tam listeyi cekene kadar hazir degiliz.
    const _meta0 = window.productVariantMeta || {};
    const _shouldLoadAll = !!(_meta0.storefrontToken && _meta0.handle &&
      (_meta0.needsMore || (_meta0.loadedCount || 0) >= 250));
    let variantsReady = !_shouldLoadAll;
    const optionGroups = $$('[data-option-group]', form);
    const priceEl = $('[data-product-price]');
    const skuEl = $('[data-product-sku]');
    const variantIdInput = $('[name="id"]', form);
    const submitBtn = $('[data-add-to-cart-btn]', form);
 
    function readSelected() {
      return optionGroups.map(group => {
        const selected = $('.is-selected', group);
        return selected ? selected.getAttribute('data-value') : null;
      });
    }
 
    // Color option grubunu bul
    function colorGroup() {
      return optionGroups.find(g => {
        const name = (g.getAttribute('data-option-name') || '').toLowerCase();
        return name === 'color' || name === 'colour' || name === 'renk';
      });
    }
 
    // Secili rengi (Color option grubundan) dondurur, yoksa null
    function selectedColor() {
      const cg = colorGroup();
      if (!cg) return null;
      const sel = $('.is-selected', cg);
      return sel ? (sel.getAttribute('data-value') || '').trim().toLowerCase() : null;
    }
 
    // COLOR etiketinin yanindaki secili renk adini gunceller (orijinal buyuk/kucuk harf)
    function updateSelectedColorLabel() {
      const cg = colorGroup();
      if (!cg) return;
      const label = $('[data-selected-color]', cg);
      if (!label) return;
      const sel = $('.is-selected', cg);
      if (sel) label.textContent = sel.getAttribute('data-value') || '';
    }

    // Her option etiketinin yanindaki secili degeri gunceller ([data-selected-value]).
    // COLOR ozel olarak [data-selected-color] kullanir; bu fonksiyon SIZE gibi
    // diger option'lar icin calisir (orijinal buyuk/kucuk harf korunur).
    function updateSelectedOptionLabels() {
      optionGroups.forEach(group => {
        const label = $('[data-selected-value]', group);
        if (!label) return;
        const sel = $('.is-selected', group);
        label.textContent = sel ? (sel.getAttribute('data-value') || '') : '';
      });
    }
 
    // Galeri gorsellerini secili renge gore filtrele + size chart'lari gizle
    function filterMediaByColor() {
      updateSelectedColorLabel();
      updateSelectedOptionLabels();
      const mediaItems = $$('.product__media-item');
      if (!mediaItems.length) return;
      const color = selectedColor();
 
      mediaItems.forEach(item => {
        const isChart = item.getAttribute('data-is-sizechart') === 'true';
        const mediaColor = (item.getAttribute('data-media-color') || '').trim().toLowerCase();
 
        // Size chart'lar ana galeride her zaman gizli
        if (isChart) { item.style.display = 'none'; return; }
 
        // Renkli urun: sadece secili rengin gorselleri gorunur.
        // Renksiz urun (mediaColor bos) veya renk secili degilse: hepsi gorunur.
        if (color && mediaColor) {
          item.style.display = (mediaColor === color) ? '' : 'none';
        } else {
          item.style.display = '';
        }
      });
    }
 
    function updateState() {
      const selected = readSelected();
      filterMediaByColor();
      if (selected.some(v => v === null)) return;
      const match = variantData.find(v => {
        return v.options.every((opt, i) => opt === selected[i]);
      });
      if (!match) {
        // Eslesme yok. Liste hala yukleniyorsa: "Loading", pasif.
        // Liste tamamsa: gercekten yok demektir -> "Sold out".
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = variantsReady
            ? (submitBtn.getAttribute('data-sold-out-label') || 'Sold out')
            : 'Loading…';
        }
        return;
      }
      if (variantIdInput) variantIdInput.value = match.id;
      if (priceEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceEl.classList.add('product__price--sale');
          priceEl.innerHTML = `<span class="price--regular">${formatMoney(match.compare_at_price)}</span><span class="price--sale">${formatMoney(match.price)}</span>`;
        } else {
          priceEl.classList.remove('product__price--sale');
          priceEl.textContent = formatMoney(match.price);
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? (submitBtn.getAttribute('data-add-label') || 'Add to bag') : (submitBtn.getAttribute('data-sold-out-label') || 'Sold out');
      }
      if (skuEl) {
        skuEl.textContent = match.sku || '';
        skuEl.style.display = match.sku ? '' : 'none';
      }
    }
 
    optionGroups.forEach(group => {
      $$('[data-value]', group).forEach(btn => {
        on(btn, 'click', () => {
          $$('[data-value]', group).forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          updateState();
        });
      });
    });
 
    // Sayfa ilk acildiginda secili renge gore filtrele + size chart gizle + renk adi
    filterMediaByColor();
 
    // ── 250+ variant: Storefront GraphQL API ile TUM varyantlari yukle ──
    // Liquid product.variants max 250 doner; /products/.js ve .json da 250'de keser.
    // 250'yi asabilen TEK public yontem Storefront GraphQL API'dir (token gerekir).
    // window.productVariantMeta.storefrontToken main-product.liquid'e gomulu.
    (function loadMissingVariants() {
      const meta = window.productVariantMeta;
      if (!_shouldLoadAll || !meta || !meta.handle || !meta.storefrontToken) return;

      const endpoint = '/api/2024-10/graphql.json';
      const token = meta.storefrontToken;
      const handle = meta.handle;
      const collected = [];

      function pageQuery(cursor) {
        const after = cursor ? ', after: "' + cursor + '"' : '';
        return '{ product(handle: "' + handle + '") { variants(first: 250' + after + ') { ' +
          'pageInfo { hasNextPage endCursor } ' +
          'edges { node { ' +
          'id title sku availableForSale ' +
          'price { amount } compareAtPrice { amount } ' +
          'selectedOptions { name value } ' +
          '} } } } }';
      }

      function fetchPage(cursor) {
        return fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token,
            Accept: 'application/json'
          },
          body: JSON.stringify({ query: pageQuery(cursor) })
        })
          .then(r => r.json())
          .then(res => {
            const prod = res && res.data && res.data.product;
            if (!prod || !prod.variants) return;
            const vs = prod.variants;
            vs.edges.forEach(e => {
              const n = e.node;
              const numericId = parseInt(String(n.id).split('/').pop(), 10);
              const opts = (n.selectedOptions || []).map(o => o.value);
              collected.push({
                id: numericId,
                available: n.availableForSale,
                price: Math.round(parseFloat(n.price.amount) * 100),
                compare_at_price: n.compareAtPrice ? Math.round(parseFloat(n.compareAtPrice.amount) * 100) : null,
                options: opts,
                title: n.title,
                sku: n.sku
              });
            });
            if (vs.pageInfo && vs.pageInfo.hasNextPage) {
              return fetchPage(vs.pageInfo.endCursor);
            }
          });
      }

      fetchPage(null)
        .then(() => {
          if (collected.length) {
            variantData = collected;
          }
          // Cevap geldi (dolu ya da bos): artik liste "hazir" kabul edilir,
          // boylece gercekten stokta olmayanlar dogru sekilde "Sold out" olur.
          variantsReady = true;
          updateState();
        })
        .catch(err => {
          console.warn('[variants] Storefront API yuklenemedi:', err);
          // Hata olsa bile kilitli "Loading" kalmasin: ilk 250'lik listeye guven.
          variantsReady = true;
          updateState();
        });
    })();
  });
 
  /* ─── Product gallery lightbox ────────────────────────────────── */
  (function productLightbox() {
    const mediaWrap = $('.product__media');
    if (!mediaWrap) return;

    // Lightbox DOM'u bir kez olustur
    const lb = document.createElement('div');
    lb.className = 'pswlb';
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML =
      '<button class="pswlb__close" aria-label="Close">&times;</button>' +
      '<button class="pswlb__nav pswlb__nav--prev" aria-label="Previous">&#8249;</button>' +
      '<img class="pswlb__img" alt="">' +
      '<button class="pswlb__nav pswlb__nav--next" aria-label="Next">&#8250;</button>' +
      '<div class="pswlb__counter"></div>';
    document.body.appendChild(lb);

    const lbImg     = $('.pswlb__img', lb);
    const lbClose   = $('.pswlb__close', lb);
    const lbPrev    = $('.pswlb__nav--prev', lb);
    const lbNext    = $('.pswlb__nav--next', lb);
    const lbCounter = $('.pswlb__counter', lb);

    let current = 0;
    let list = []; // o an gorunur olan <img> elemanlari

    // Sadece GORUNUR (renge gore filtrelenmis, gizli olmayan) gorselleri topla
    function visibleImages() {
      return $$('.product__media-item', mediaWrap)
        .filter(item => item.style.display !== 'none' &&
                        item.getAttribute('data-is-sizechart') !== 'true')
        .map(item => $('img', item))
        .filter(Boolean);
    }

    // En yuksek cozunurluklu kaynagi sec (srcset varsa son aday, yoksa src)
    function bigSrc(img) {
      const ss = img.getAttribute('srcset');
      if (ss) {
        const parts = ss.split(',').map(s => s.trim().split(/\s+/)[0]).filter(Boolean);
        if (parts.length) return parts[parts.length - 1];
      }
      return img.currentSrc || img.src;
    }

    function show(i) {
      if (!list.length) return;
      current = (i + list.length) % list.length;
      const img = list[current];
      lbImg.src = bigSrc(img);
      lbImg.alt = img.alt || '';
      lbCounter.textContent = (current + 1) + ' / ' + list.length;
      const multi = list.length > 1;
      lbPrev.style.display = multi ? '' : 'none';
      lbNext.style.display = multi ? '' : 'none';
      lbCounter.style.display = multi ? '' : 'none';
    }

    function openAt(img) {
      list = visibleImages();
      const idx = list.indexOf(img);
      if (idx < 0) return;
      show(idx);
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      lbImg.src = '';
    }

    // Galeri gorsellerine tiklama (delegasyon — async yuklenen gorseller icin de calisir)
    on(mediaWrap, 'click', (e) => {
      const img = e.target.closest('.product__media-item img');
      if (!img) return;
      const item = img.closest('.product__media-item');
      if (item && item.getAttribute('data-is-sizechart') === 'true') return;
      e.preventDefault();
      openAt(img);
    });

    on(lbClose, 'click', close);
    on(lbPrev, 'click', (e) => { e.stopPropagation(); show(current - 1); });
    on(lbNext, 'click', (e) => { e.stopPropagation(); show(current + 1); });
    // Arka plana (resim/ok disi) tiklayinca kapat
    on(lb, 'click', (e) => { if (e.target === lb) close(); });

    on(document, 'keydown', (e) => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });
  })();

  /* ─── Init ────────────────────────────────────────────────────── */
  refreshCart();
})();